import { UPDATE_SLOTS_STATUS } from "@graphql"
import { useMutation } from "@apollo/client"

const useUpdateSlotStatus = () => {
  const [updateSlotStatus, {data, loading, error}] = useMutation(UPDATE_SLOTS_STATUS)

  return {
    updateSlotStatus,
    data,
    loading,
    error,
  }
}

export default useUpdateSlotStatus